module.exports = __webpack_public_path__ + "7b5fb88f12bec8143f00e21bc3222124.ttf";